class SlideShowTouch {

    constructor (container) {
        this.container         = container
        this.nodes             = container.children
        this.nodesLng          = container.children.length
        this.clientWidth       = container.clientWidth
        this.touchStartX       = undefined
        this.touchMoveX        = undefined
        this.moveX             = undefined
        this.index             = 0
        this.longTouch         = false
        this.controllers       = container.parentElement.querySelectorAll('.slideshow__home__index')
        this.currentController = container.parentElement.querySelector('.slideshow__home__index')
        this.rwd               = undefined
    }

    init() {

        this.rwd = (this.container.hasAttribute('data-slide-rwd')) ? this.container.getAttribute('data-slide-rwd') : ' + this.rwd + '
        
        if (window.matchMedia('(min-width: ' + this.rwd + 'px)').matches) 
            return this.container.style.transform = ''
        
        this.bindUIEvents()
    }

    bindUIEvents() {
        this.container.addEventListener('touchstart', this.touchStart.bind(this))
        this.container.addEventListener('touchmove', this.touchMove.bind(this))
        this.container.addEventListener('touchend', this.touchEnd.bind(this))
    }

    touchStart(e) {

        if (window.matchMedia('(min-width: ' + this.rwd + 'px)').matches) return

        this.touchStartX = e.touches[0].pageX
    }

    touchMove(e) {

        if (window.matchMedia('(min-width: ' + this.rwd + 'px)').matches) return

        this.touchMoveX = e.touches[0].pageX
        this.moveX = (this.index * this.clientWidth + (this.touchStartX - this.touchMoveX))

        let state = this.touchStartX - this.touchMoveX,
            translate = this.nodes[0].clientWidth * this.index,
            nodeClientWidth = this.nodes[0].clientWidth,
            maxSize         = nodeClientWidth - (nodeClientWidth / 3)

        if (state < maxSize && state > -maxSize)
            this.container.style.transform = 'translate3d(' + (-translate - state) + 'px, 0, 0)'
    }

    touchEnd() {

        if (window.matchMedia('(min-width: ' + this.rwd + 'px)').matches) return

        let absMove   = Math.abs(this.index * this.clientWidth - this.moveX),
            translate = -this.nodes[0].clientWidth
        
        
        if (absMove > (this.clientWidth / 2)) {
            if (this.moveX > this.index * this.clientWidth && this.index < (this.nodesLng - 1))
                this.index++
            else if (this.moveX < this.index * this.clientWidth && this.index > 0) {
                this.index--
            }
        }

        let res = (this.container.hasAttribute('data-slide-gutter')) ? translate * this.index - this.container.getAttribute('data-slide-gutter') * this.index : translate * this.index
        this.container.style.transform = 'translate3d(' + res + 'px, 0, 0)'
        
        if (!this.currentController) return 

        this.currentController.classList.remove('trigger')
        this.currentController = this.controllers[this.index]
        this.currentController.classList.add('trigger')
    }
}

const displaySlideHome = (el) => {

    let width = document.querySelector('.presentation__inner') ? document.querySelector('.presentation__inner').getAttribute('data-slide-rwd') : 768

    if (el.classList.contains('trigger') || !window.matchMedia('(min-width: ' + width + 'px)').matches) return 

    document.querySelector('.slideshow-home-item.trigger').classList.remove('trigger')
    el.classList.add('trigger')
}

class SlideShowOverlay {

    constructor (trigger, container) {
        this.trigger      = trigger
        this.interval     = undefined
        this.slideshow    = container
        this.slides       = Array.from(this.slideshow.querySelectorAll('.slideshow__overlay__item'))
        this.currentSlide = document.querySelector('.slideshow__overlay__item.trigger')
        this.index        = 0
        this.timing       = 4000
    }

    registerEvents() {
        this.trigger.addEventListener('click', this.displayOverlay.bind(this))
        this.slideshow.addEventListener('click', this.handleClick.bind(this))
    }

    displayOverlay(e) {
        let overlay = this.trigger.querySelector('.overlay')

		if (overlay)
			overlay.classList.remove('overlay--animate')
		else {
			overlay = document.createElement('div')
			overlay.classList.add('overlay')
			overlay.style.width = overlay.style.height = Math.max(this.trigger.offsetWidth, this.trigger.offsetHeight) + 'px'
			this.trigger.appendChild(overlay)
		}

		overlay.style.left = (e.offsetX - overlay.offsetWidth / 2) + 'px'
		overlay.style.top = (e.offsetY - overlay.offsetHeight / 2) + 'px'
		overlay.classList.add('overlay--animate')

        if (this.slideshow.classList.contains('hidden')) this.slideshow.classList.remove('hidden')

        this.slideshow.classList.add('trigger')
        return this.defineInterval()
    }

    handleSlide(direction = 1) {
        
        this.index = this.index + direction
        
        if (this.index < 0) this.index = this.slides.length - 1
        if (this.index === this.slides.length) this.index = 0

        this.currentSlide.classList.remove('trigger')
        this.currentSlide = this.slides[this.index]
        this.currentSlide.classList.add('trigger')
    }

    defineInterval() {
        this.interval = window.setInterval(this.handleSlide.bind(this), this.timing)
    }

    resetInterval() {
        clearInterval(this.interval)
        this.defineInterval()
    }

    handleClick(e) {
        let el = e.target

        if (el.classList.contains('previous')) {
            this.handleSlide(-1)
            return this.resetInterval()
        }

        if (el.classList.contains('next')) {
            this.handleSlide()
            return this.resetInterval()
        }

        if (el.classList.contains('slideshow-overlay-close'))
            return this.closeSlideshow()
    }

    closeSlideshow() {
        clearInterval(this.interval)
        
        if (this.index !== 0) {
            this.currentSlide.classList.remove('trigger')
            this.index = 0
            this.currentSlide = this.slides[this.index]
            this.currentSlide.classList.add('trigger')
        }

        this.slideshow.classList.add('hidden')

        setTimeout(() => {
            this.slideshow.classList.remove('trigger')
        }, 250)
    }
}

const displaySlideArticle = el => {
    let dir       = el.classList.contains('previous') ? -1 : 1,
        container = el.closest('.article__gallery'),
        slides    = Array.from(container.querySelectorAll('.article__img')),
        current   = container.querySelector('.article__img.trigger'),
        index     = slides.indexOf(current)

    index = index + dir

    if (index < 0) index = slides.length - 1
    if (index === slides.length) index = 0

    current.classList.remove('trigger')
    slides[index].classList.add('trigger')
}

export {
    SlideShowTouch,
    displaySlideHome,
    SlideShowOverlay,
    displaySlideArticle
}